<template>
	<div class="container mx-auto">
		<form :action="route('interventions.store')" method="POST">
			<div class="grid md:grid-cols-4 sm:grid-cols-1 gap-4">
				<!-- <div class="col-span-full">
          <a :href="navigate(route('interventions.print', this.id))">Stampa</a>
        </div> -->
				<div class="col-span-2">
					<label for="number" class="block text-sm font-medium text-gray-700"
						>Numero di intervento</label
					>
					<t-input
						name="number"
						v-model="model.intervention.number"
						placeholder="Numero intervento"
						readonly
						disabled
					></t-input>
				</div>

				<div class="col-span-2">
					<span class="justify-end">
						<label for="reviewed">Revisionato?</label>
						<t-toggle name="reviewed" v-model="model.intervention.reviewed" />
					</span>
				</div>

				<div class="col-span-2">
					<label for="type">Tipo di intervento</label>
					<t-select
						name="type"
						v-model="model.intervention.type"
						:options="dTypes"
						text-attribute="text"
						value-attribute="id"
					></t-select>
				</div>

				<div class="col-span-1">
					<span class="justify-end">
						<label for="charge_free">Gratuito</label>
						<t-toggle
							name="charge_free"
							v-model="model.intervention.charge_free"
						/>
					</span>
				</div>

				<div class="col-span-1">
					<span class="justify-end">
						<label for="draft">Bozza</label>
						<t-toggle name="draft" v-model="model.intervention.draft" />
					</span>
				</div>

				<div class="col-span-full">
					<label for="client" class="block text-sm font-medium text-gray-700"
						>Cliente *</label
					>

					<t-rich-select
						ref="clientPicker"
						name="client"
						v-model="model.intervention.client_id"
						:fetch-options="fetchClients"
						placeholder="Seleziona un cliente"
						value-attribute="id"
						text-attribute="code"
						:variant="{ danger: dErrors.client_id }"
						@change="
							() => {
								if (isNew) {
									model.intervention.activities = [];
								}
							}
						"
					>
						<template slot="label" slot-scope="{ className, option, query }">
							<div class="flex">
								<!-- <span class="flex-shrink-0">
				  <img
					class="w-10 h-10 rounded-full"
					:src="option.raw.owner.avatar_url"
				  />
				</span> -->
								<div class="flex flex-col ml-2 text-gray-800">
									<strong>{{ option.raw.code }}</strong>
									<span class="text-sm leading-tight text-gray-700">{{
										option.raw.business_name
									}}</span>
								</div>
							</div>
						</template>

						<template
							slot="option"
							slot-scope="{
								index,
								isHighlighted,
								isSelected,
								className,
								option,
								query,
							}"
						>
							<div :class="className">
								<!-- <span class="flex-shrink-0">
				  <img
					class="w-10 h-10 rounded-full"
					:src="option.raw.owner.avatar_url"
				  />
				</span> -->
								<div class="flex flex-col w-full ml-2 text-gray-800">
									<strong>
										{{ option.raw.code }}
										<span v-if="isSelected">(Selezionato)</span>
									</strong>
									<span class="text-sm leading-tight text-gray-700">{{
										option.raw.business_name
									}}</span>
								</div>
							</div>
						</template>
					</t-rich-select>
					<div
						v-if="dErrors.client_id"
						class="p-1 bg-red-200 text-red-800 opacity-75 rounded"
					>
						{{ dErrors.client_id[0] }}
					</div>
				</div>

				<div class="col-span-2">
					<label for="date_begin">Data inizio *</label>
					<t-datepicker
						name="date_begin"
						:disable-dates="
							(date) => {
								return date > new Date();
							}
						"
						v-model="model.intervention.date_begin"
						:max-date="new Date()"
						:week-start="1"
						:variant="{ danger: dErrors.date_begin }"
					></t-datepicker>
					<div
						v-if="dErrors.date_begin"
						class="p-1 bg-red-200 text-red-800 opacity-75 rounded"
					>
						{{ dErrors.date_begin[0] }}
					</div>
				</div>
				<div class="col-span-2">
					<label for="date_end">Data fine</label>
					<t-datepicker
						name="date_end"
						:disable-dates="
							(date) => {
								return date > model.intervention.date_begin;
							}
						"
						v-model="model.intervention.date_end"
						:min-date="model.intervention.date_begin"
						:week-start="1"
					></t-datepicker>
				</div>

				<div class="col-span-full">
					<label for="reason">Motivazione *</label>
					<t-textarea
						name="reason"
						v-model="model.intervention.reason"
						:variant="{ danger: dErrors.reason }"
						maxlength="255"
						required
					/>
					<div
						v-if="dErrors.reason"
						class="p-1 bg-red-200 text-red-800 opacity-75 rounded"
					>
						{{ dErrors.reason[0] }}
					</div>
				</div>

				<div class="col-span-full">
					<label for="note">Note</label>
					<t-textarea name="note" v-model="model.intervention.note" />
				</div>
			</div>

			<div class="border-t-4 border-neutral-400 my-4 pt-2">
				<h3>Attività eseguite</h3>
				<div>
					<t-button
						native
						@click.prevent="addActivity"
						:disabled="!model.intervention.client_id"
						variant="secondary"
						>Aggiungi attività</t-button
					>
				</div>

				<t-card
					v-for="(activity, activityIdx) in model.intervention.activities"
					v-bind:key="activityIdx"
				>
					<template v-slot:header>
						<div class="flex justify justify-between">
							<div>
								<h5>{{ `Attività ${Number(activityIdx) + 1}` }}</h5>
							</div>
							<div class="flex justify justify-between">
								<div v-if="!activity.deleted">
									<t-button
										type="button"
										@click="removeActivity(activityIdx)"
										variant="error"
										>Elimina</t-button
									>
								</div>
								<div v-else class="flex justify justify-between gap-2">
									<t-tag variant="badge">
										<i class="fa fa-trash fa-2x text-red-700"></i>
									</t-tag>

									<t-button
										type="button"
										@click="restoreActivity(activityIdx)"
										variant="secondary"
										>Ripristina</t-button
									>
								</div>
							</div>
						</div>
					</template>

					<div
						class="grid grid-cols-2 gap-4"
						:class="{ 'opacity-25': activity.deleted }"
					>
						<div class="grid gap-4">
							<div>
								<label
									for="machine"
									class="block text-sm font-medium text-gray-700"
									>Macchina *</label
								>

								<t-rich-select
									ref="machinePicker"
									name="machine"
									v-model="activity.machine_id"
									:fetch-options="fetchMachines"
									placeholder="Seleziona una macchina"
									value-attribute="id"
									text-attribute="serial_number"
									:variant="{
										danger: dErrors[`activities.${activityIdx}.machine_id`],
									}"
									required
								>
									<template
										slot="label"
										slot-scope="{ className, option, query }"
									>
										<div class="flex">
											<div class="flex flex-col ml-2 text-gray-800">
												<strong>{{ option.raw.serial_number }}</strong>
												<span class="text-sm leading-tight text-gray-700">{{
													option.raw.details.description
												}}</span>
											</div>
										</div>
									</template>

									<template
										slot="option"
										slot-scope="{ isSelected, className, option }"
									>
										<div :class="className">
											<!-- <span class="flex-shrink-0">
					<img
						class="w-10 h-10 rounded-full"
						:src="option.raw.owner.avatar_url"
					/>
					</span> -->
											<div class="flex flex-col w-full ml-2 text-gray-800">
												<strong
													>{{ option.raw.serial_number }} -
													{{ option.raw.details.model }} ({{
														option.raw.details.brand
													}})
													<span v-if="isSelected">(Selezionato)</span>
												</strong>
												<span class="text-sm leading-tight text-gray-700">{{
													option.raw.details.description
												}}</span>
											</div>
										</div>
									</template>
								</t-rich-select>
								<div
									v-if="dErrors[`activities.${activityIdx}.machine_id`]"
									class="p-1 bg-red-200 text-red-800 opacity-75 rounded"
								>
									{{ dErrors[`activities.${activityIdx}.machine_id`][0] }}
								</div>
							</div>

							<div>
								<span>
									Macchina non in elenco?
									<t-toggle v-model="activity.notFound" />
								</span>
								<div v-if="notFound">
									<label for="">Indicare il numero della matricola</label>
									<t-input
										v-model="activity.alternative_machine_serial"
										:variant="{
											danger:
												dErrors[
													`activities.${activityIdx}.alternative_machine_serial`
												],
										}"
									></t-input>
									<div
										v-if="
											dErrors[
												`activities.${activityIdx}.alternative_machine_serial`
											]
										"
										class="p-1 bg-red-200 text-red-800 opacity-75 rounded"
									>
										{{
											dErrors[
												`activities.${activityIdx}.alternative_machine_serial`
											][0]
										}}
									</div>
								</div>
							</div>
						</div>

						<div class="grid gap-4" v-if="model.intervention.type == 2">
							<div>
								<label
									for="substitute_machine"
									class="block text-sm font-medium text-gray-700"
									>Macchina in sostituzione</label
								>
								<t-rich-select
									name="substitute_machine"
									v-model="activity.substitute_machine_id"
									:fetch-options="fetchMachines"
									placeholder="Seleziona una macchina"
									value-attribute="id"
									text-attribute="serial_number"
								>
									<template
										slot="label"
										slot-scope="{ className, option, query }"
									>
										<div class="flex">
											<!-- <span class="flex-shrink-0">
					<img
						class="w-10 h-10 rounded-full"
						:src="option.raw.owner.avatar_url"
					/>
					</span> -->
											<div class="flex flex-col ml-2 text-gray-800">
												<strong>{{ option.raw.serial_number }}</strong>
												<span class="text-sm leading-tight text-gray-700">{{
													option.raw.model
												}}</span>
											</div>
										</div>
									</template>

									<template
										slot="option"
										slot-scope="{ isSelected, className, option }"
									>
										<div :class="className">
											<!-- <span class="flex-shrink-0">
					<img
						class="w-10 h-10 rounded-full"
						:src="option.raw.owner.avatar_url"
					/>
					</span> -->
											<div class="flex flex-col w-full ml-2 text-gray-800">
												<strong
													>{{ option.raw.serial_number }} -
													{{ option.raw.details.model }} ({{
														option.raw.details.brand
													}})
													<span v-if="isSelected">(Selected)</span>
												</strong>
												<span class="text-sm leading-tight text-gray-700">{{
													option.raw.details.description
												}}</span>
											</div>
										</div>
									</template>
								</t-rich-select>
							</div>

							<div>
								<span>
									Macchina non in elenco?
									<t-toggle v-model="notFoundSub" />
								</span>
								<div v-if="notFoundSub">
									<label for="">Indicare il numero della matricola</label>
									<t-input
										v-model="activity.alternative_sub_machine_serial"
									></t-input>
								</div>
							</div>
						</div>

						<div>
							<label for="">Svolto presso</label>
							<t-select
								:options="dPlaces"
								v-model="activity.operating_place_id"
								text-attribute="text"
								value-attribute="id"
							></t-select>
						</div>

						<div class="col-auto">
							<div>
								<label for="reviewed">Specificare date diverse?</label>
								<t-toggle name="reviewed" v-model="activity.altDates" />
							</div>
							<div v-if="activity.altDates">
								<div>
									<label for="date_begin">Data inizio *</label>
									<t-datepicker
										name="date_begin"
										v-model="activity.date_begin"
										required
									></t-datepicker>
								</div>
								<div>
									<label for="date_end">Data fine</label>
									<t-datepicker
										name="date_end"
										v-model="activity.date_end"
										:min-date="activity.date_begin"
									></t-datepicker>
								</div>
							</div>
						</div>

						<div class="col-span-full">
							<label for="description">Descrizione *</label>
							<t-textarea
								name="description"
								v-model="activity.description"
								:variant="{
									danger: dErrors[`activities.${activityIdx}.description`],
								}"
								required
							/>
							<div
								v-if="dErrors[`activities.${activityIdx}.description`]"
								class="p-1 bg-red-200 text-red-800 opacity-75 rounded"
							>
								{{ dErrors[`activities.${activityIdx}.description`][0] }}
							</div>
						</div>

						<div>
							<t-button
								type="button"
								@click.prevent="$modal.show('spare-dialog', activity)"
								variant="secondary"
								>Aggiungi ricambio</t-button
							>
						</div>

						<div class="col-span-full">
							<t-card
								v-for="(spare, spareIdx) in activity.components"
								v-bind:key="spareIdx"
							>
								<template v-slot:header>
									<div class="flex justify justify-between">
										<div>
											<h5>{{ `Ricambio ${Number(spareIdx) + 1}` }}</h5>
										</div>
										<div>
											<t-button
												type="button"
												@click="removeSpare(activityIdx, spareIdx)"
												variant="error"
												>Elimina</t-button
											>
										</div>
									</div>
								</template>

								<div class="grid grid-cols-2 gap-4">
									<div>
										<span>Codice:</span>
										<span class="ml-1">{{ spare.products_code }}</span>
									</div>
									<div>
										<span>Descrizione:</span>
										<span class="ml-1">{{ spare.description }}</span>
									</div>
									<div>
										<label for="quantity">Quantità</label>
										<t-input
											name="quantity"
											type="number"
											v-model="spare.quantity"
										></t-input>
									</div>
									<div>
										<label for="multiplier">Sconto</label>
										<t-input
											name="multiplier"
											type="number"
											v-model="spare.multiplier"
										></t-input>
									</div>
									<div>
										<span>Prezzo</span>
										<span>{{ spare.price }} €</span>
									</div>
									<div>
										<span>Gratuito</span>
										<t-toggle />
									</div>
									<div>
										<span>Totale</span>
										<span
											>{{
												spare.price * spare.quantity * spare._multiplier
											}}
											€</span
										>
									</div>
								</div>
							</t-card>
						</div>
					</div>
				</t-card>
			</div>

			<t-card
				class="my-8"
				header="Firma del cliente"
				v-show="model.intervention.client_id"
			>
				<template v-slot:header>
					<div class="flex justify-between">
						<span>Firma del Cliente</span>
						<t-badge
							v-if="isSigned"
							tag-name="span"
							variant="badge"
							class="
								inline-flex
								items-center
								px-3
								rounded-full
								text-xs
								font-medium
								leading-4
								bg-green-100
								text-green-800
							"
							>Firmato</t-badge
						>
						<t-badge
							v-else
							tag-name="span"
							variant="badge"
							class="
								inline-flex
								items-center
								px-3
								rounded-full
								text-xs
								font-medium
								leading-4
								bg-red-100
								text-red-800
							"
							>Non firmato</t-badge
						>
					</div>
				</template>

				<div class="grid grid-cols-2 gap-4">
					<div>
						<label for="referee_firstname">Nome</label>
						<t-input
							name="referee_firstname"
							label="Nome"
							v-model="model.intervention.referee_firstname"
							:readonly="!!model.intervention.number"
						></t-input>
					</div>
					<div>
						<label for="referee_lastname">Cognome</label>
						<t-input
							name="referee_lastname"
							label="Cognome"
							v-model="model.intervention.referee_lastname"
							:readonly="!!model.intervention.number"
						></t-input>
					</div>
					<div class="col-span-full">
						<span>Firma</span>
						<vue-signature-pad
							v-if="!model.intervention.number"
							width="100%"
							height="200px"
							ref="signaturePad"
							:options="signatureOptions"
							:custom-style="signaturePadStyle"
						></vue-signature-pad>
						<div v-else>
							<img
								width="100%"
								height="200px"
								:src="model.intervention.signature"
							/>
						</div>
					</div>
				</div>

				<template v-slot:footer v-if="!model.intervention.number">
					<div class="flex justify-between">
						<t-button
							type="button"
							variant="secondary"
							@click="signaturePadClear"
							>Cancella</t-button
						>
					</div>
				</template>
			</t-card>

			<div class="flex justify-end">
				<t-button type="button" @click.stop="submit">Salva intervento</t-button>
			</div>
		</form>

		<!-- Modal to pick up a spare part -->
		<t-modal
			name="spare-dialog"
			icon="question"
			@before-open="({ params }) => (activity = params)"
		>
			<template v-slot:default>
				<t-rich-select
					name="spare"
					v-model="part"
					:fetch-options="fetchSpares"
					placeholder="Seleziona i ricambi"
					value-attribute="code"
					text-attribute="code"
				>
					<template slot="label" slot-scope="{ option }">
						<div class="flex">
							<div class="flex flex-col ml-2 text-gray-800">
								<strong>{{ option.raw.code }}</strong>
								<span class="text-sm leading-tight text-gray-700">{{
									option.raw.description
								}}</span>
							</div>
						</div>
					</template>

					<template
						slot="option"
						slot-scope="{ isSelected, className, option }"
					>
						<div :class="className">
							<div class="flex flex-col w-full ml-2 text-gray-800">
								<strong>
									{{ option.raw.code }}
									<span v-if="isSelected">(Selected)</span>
								</strong>
								<span class="text-sm leading-tight text-gray-700">{{
									option.raw.description
								}}</span>
							</div>
						</div>
					</template>
				</t-rich-select>
			</template>
			<template v-slot:footer>
				<div class="flex justify-between">
					<t-button type="button" @click="$modal.hide('spare-dialog')"
						>Annulla</t-button
					>
					<t-button
						type="button"
						@click="
							addSpare(activity, part);
							$modal.hide('spare-dialog');
						"
						>Conferma</t-button
					>
				</div>
			</template>
		</t-modal>

		<!-- <t-dialog
		name="chg-client-dialog"
		icon="question"
		type="confirm"
	>
	  <template slot="title"> Cambiando cliente si perdono tutte le attività registrate. Proseguire? </template>

	  <p>Questa azione non può essere annullata.</p>

	  <template slot="icon">
		<svg
		  class="w-6 h-6"
		  fill="none"
		  stroke="currentColor"
		  viewBox="0 0 24 24"
		  xmlns="http://www.w3.org/2000/svg"
		>
		  <path
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
			d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
		  />
		</svg>
	  </template>
	</t-dialog> -->
	</div>
</template>

<script>
import Asyncable from "@mixins/Asyncable";
// import Responsable from "@mixins/Responsable";

import { VueSignaturePad } from "vue-signature-pad";

var moment = require("moment");

const optionsPerPage = 20;

class Intervention {
	constructor() {
		this.number = null;
		this.client_id = null;
		this.date_begin = moment().format("Y-MM-DD");
		this.date_end = null;
		this.reason = null;
		this.diagnose = null;
		this._status = 1;
		this.type = 1;
		this.operator = null;
		this.note = null;
		this.referee_firstname = null;
		this.referee_lastname = null;
		this.activities = [];
        this.signatureData = null;
	}

	set status(value) {
		this.status = value;
	}

	get status() {
		if (!!this.date_end) this._status = 3;
		else this._status = 1;
		return this._status;
	}
}

class Activity {
	constructor(activity = null) {
		this.id = null;
		this.name = null;
		this.machine_id = null;
		this.description = null;
		this.date_begin = moment().format("Y-MM-DD");
		this.date_end = null;
		this.type = null;
		this.return = false;
		this.operating_place = 1;
		this._components = [];
		this.deleted = false;
	}

	get components() {
		return this._components;
	}

	set components(items) {
		for (let index in items) {
			let spare = new Spare(items[index]);
			this._components.push(spare);
		}
	}
}

class Spare {
	constructor(item) {
		this.products_code = item.code;
		this.description = item.description;
		this.quantity = 1;
		this.price = item.price;
		this.price_multiplier = item.multiplier || 1;
		this._multiplier = item.multiplier || 1;
		this.free = !this.price;
	}

	get multiplier() {
		return this._multiplier * 100;
	}

	set multiplier(value) {
		this._multiplier = value / 100;
		this.price_multiplier = this._multiplier;
	}
}

var intervalID = undefined;

export default {
	props: {
		id: {
			type: Number,
			required: false,
			default: undefined,
		},

		user: {
			type: Number,
			require: false,
			default: undefined,
		},
	},

	mixins: [
		Asyncable,
		//   Responsable
	],

	components: {
		VueSignaturePad,
	},

	mounted() {
		if (this.id) {
			this.fetchIntervention(this.id);
		} else {
			this.model.intervention.operator = this.user;

            intervalID = setInterval(() => {
				if (!this.$refs.signaturePad.isEmpty()) {
					this.signIntervention();
				}
			}, 1000);
            console.log("set interval: %d", intervalID);
		}

		this.fetchClients();
		this.fetchMachines();
		this.fetchSpares();
	},

	data() {
		return {
			model: {
				intervention: new Intervention()
			},

			dErrors: {},

			dClients: null,
			dMachines: null,
			dSpares: null,
			dTypes: [
				{ id: 1, text: "Intervento manutenzione" },
				{ id: 2, text: "Ritiro/sostituzione macchina" },
			],
			dPlaces: [
				{ id: 1, text: "Presso Cliente" },
				{ id: 2, text: "In Officina" },
			],
			part: undefined,

			chooseSpare: false,

			notFound: false,
			notFoundSub: false,
			substitution: false,

			signatureOptions: {
				penColor: "#444",
				onBegin: () => {
					this.$refs.signaturePad.resizeCanvas();
				},
			},

			signaturePadStyle: {
				border: "1px #999 solid",
			},
		};
	},

	watch: {},

	computed: {
		clientDisplayedText() {
			if (!this.dClient || !Object.keys(this.dClient).length) {
				return null;
			}
			return this.$string.sprintf(
				"[%s] %s",
				this.dClient.code,
				this.dClient.business_name
			);
		},

		isDateEndValid() {
			if (
				!this.model.intervention.date_begin ||
				!this.model.intervention.date_end
			) {
				return true;
			}

			return (
				Date(this.model.intervention.date_begin) <=
				Date(this.model.intervention.date_end)
			);
		},

		isSigned() {
			return !!this.model.intervention.signatureData;
		},

		isNew() {
			return !this.model.intervention.number;
		},
	},

	methods: {
		fetchIntervention(number) {
			this.$awn.asyncBlock(
				this.asyncGet(route("interventions.show", { id: number })),
				({ data }) => {
					this.model.intervention = data.data;
				}
			);
		},

		machineDisplayedText(machine) {
			if (machine) {
				return this.$string.sprintf(
					"[%s] %s - %s",
					machine.product_code,
					machine.serial_number,
					machine.description || "Nessuna descrizione"
				);
			}
			return null;
		},

		/**
		 * Handler of the event after the user choose a client.
		 *
		 * @param      {Object}  client  The client chosen.
		 */
		onCustomerChoice(client) {
			this.model.client = client;
			this.model.intervention.client = client.code;
		},

		/**
		 * Adds an activity to the intervention's list.
		 */
		addActivity() {
			let activity = new Activity();

			this.model.intervention.activities.push(activity);

			//   this.model.activities.push(activity);
		},

		/**
		 * Removes in-place an activity from the list of intervention's
		 * activities at provided index 'index'.
		 *
		 * @param      {int}  index   The index in the lsit of the activity to remove.
		 */
		removeActivity(activityIdx) {
			// this.$awn.confirm(
			// 	`Vuoi eliminare l'attività no. ${activityIdx + 1}?`,
			// 	() => {
			if (this.model.intervention.activities[activityIdx].intervention_number)
				this.model.intervention.activities[activityIdx].deleted = true;
			else this.model.intervention.activities.splice(activityIdx, 1);
			// }
			// );
		},

		/**
		 * Restore in-place an activity from the list of intervention's
		 * activities at provided index 'index'.
		 *
		 * @param      {int}  index   The index in the lsit of the activity to restore.
		 */
		restoreActivity(activityIdx) {
			this.model.intervention.activities[activityIdx].deleted = false;
		},

		/**
		 * Adds a spare part to the intevention's list.
		 *
		 * @param      {String}  code    The item's code to add.
		 */
		addSpare(activity, code) {
			var item = this.dSpares.find((item) => item.code == code);

			console.log(code, item);

			// Adds the spare part to the list
			activity.components.push(new Spare(item));
		},

		/**
		 * Removes a spare.
		 *
		 * @param      {int}  index   The index in the list of the spare to remove.
		 */
		removeSpare(activityIdx, spareIdx) {
			this.$awn.confirm(
				`Vuoi eliminare il componente ${this.model.intervention.activities[activityIdx].components[spareIdx].code}?`,
				() => {
					if (!this.isNew)
						this.model.intervention.activities[activityIdx].components[
							spareIdx
						].deleted = true;
					else
						this.model.intervention.activities[activityIdx].components.splice(
							spareIdx,
							1
						);
				}
			);
		},

		signIntervention() {
			const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
			this.model.intervention.signatureData = data;
		},

		signaturePadClear() {
			this.$refs.signaturePad.clearSignature();
			this.model.intervention.signatureData = null;
		},

		checkSignature() {
			this.$awn.confirm(
				"Attenzione non l'intervention non è stato firmato, si vuole procedere al salvataggio comunque?",
				() => true
			);
		},

		async fetchClients(query, nextPage = 1) {
			if (!this.dClients || !this.dClients.length) {
				var response = await axios.get(route("clients.index"));
				this.dClients = response.data.data;
			}

			query = query ? query.toLowerCase() : null;

			var filtered = this.dClients.filter((item) => {
				return (
					!query ||
					item.code.toLowerCase().includes(query) ||
					item.business_name.toLowerCase().includes(query)
				);
			});

			// return {
			// 	results: this.paginate(filtered, optionsPerPage, nextPage),
			// 	hasMorePages: filtered.length > nextPage * optionsPerPage,
			// };

            return {
                results: filtered,
                hasMorePages: false
            };
		},

		async fetchMachines(query, nextPage = 1) {
			if (!this.dMachines || !this.dMachines.length) {
				var response = await axios.get(
					//   route("machines.index", { client: this.model.intervention.client_id })
					route("machines.index")
				);
				this.dMachines = response.data.data;
			}

			query = query ? query.toLowerCase() : null;

			var filtered = this.dMachines.filter((item) => {
				return (
					!query ||
					item.serial_number.toLowerCase().includes(query) ||
					(item.details && item.details.model.toLowerCase().includes(query))
				);
			});

			// return {
			// 	results: this.paginate(filtered, optionsPerPage, nextPage),
			// 	hasMorePages: filtered.length > nextPage * optionsPerPage,
			// };

            return {
                results: filtered,
                hasMorePages: false
            };
		},

		async fetchSpares(query, nextPage = 1) {
			if (!this.dSpares || !this.dSpares.length) {
				var response = await axios.get(route("products.index"));
				this.dSpares = response.data.data;
			}

			//   this.dSpares = this.dSpares.map(item => ({value: item.code, text: item.description}));

			query = query ? query.toLowerCase() : null;

			var filtered = this.dSpares.filter((item) => {
				return (
					!query ||
					item.code.toLowerCase().includes(query) ||
					(item.description && item.description.toLowerCase().includes(query))
				);
			});

			//   filtered = filtered.map((item) => ({ code: item.code, item }));

			// return {
			// 	results: this.paginate(filtered, optionsPerPage, nextPage),
			// 	hasMorePages: filtered.length > nextPage * optionsPerPage,
			// };

            return {
                results: filtered,
                hasMorePages: false
            };
		},

		async submit() {
			//   var response = null;
			var endpoint = null;
			this.dErrors = {};

			if (this.id) {
				endpoint = axios.put.bind(
					this,
					route("interventions.update", { id: this.id }),
					this.model.intervention
				);
			} else {
				endpoint = axios.post.bind(
					this,
					route("interventions.store"),
					this.model.intervention
				);
			}

			this.$awn.async(
				endpoint.call(),
				(response) => {
					switch (response.status) {
						case 200:
							this.$awn.success("Intervento salvato con successo!");
							// this.fetchIntervention(response.data.number);
							if (!this.id) {
								// /*
                                //  * Se si tratta di nuovo intervento, mentre ricarica la pagina per consentire
                                //  * di modificarlo nuovamente, richiede la conferma se si vuole anche creare un
                                //  * nuovo intervento.
                                //  */
								// this.navigate(
								// 	route("interventions.edit", {
								// 		intervention: response.data.number,
								// 	}),
								// 	false
								// );

                                // // Conferma per creazione nuovo intervento
								// this.$awn.confirm("Creare un nuovo intervento", () =>
								// 	this.resetData()
								// );

                                // Auto redirezione alla pagina di stampa (nuova tab)
								setTimeout(() => {
									this.navigate(
										route("interventions.print", {
											intervention: response.data.number,
										}),
										true
									);
								}, 3000);
							} else {
								this.model.intervention = response.data.data;
							}
							break;
						case 400:
							this.$awn.warning(
								"L'operazione non è andata a buon fine. <br>" +
									response.data.errors.join("<br>")
							);
							break;
					}
				},
				(error) => {
					if (!this.isOnline()) {
						this.$awn.warning(
							"Attenzione si è offline, la richiesta verrà salvata e inviata appena possibile"
						);
						return;
					}
					this.dErrors = error.response.data.errors || {};
					this.$awn.alert(
						"Errore nel salvataggio:<br>" + error.response.data.message
					);
				},
				"Salvataggio in corso..."
			);

			//   if (this.id) {
			//     response = await axios.put(
			//       route("interventions.update", { id: this.id }),
			//       this.model
			//     );
			//   } else {
			//     try {
			//       response = await axios.post(route("interventions.store"), this.model);
			//     } catch (error) {
			//       if (!this.isOnline()) {
			//         this.$awn.warning(
			//           "Attenzione si è offline, la richiesta verrà salvata e inviata appena possibile"
			//         );

			//         return;
			//       }
			//     }
			//   }

			//   if (response && response.status == 200) {
			//     this.$awn.success("Intervento salvato con successo!");
			//     this.fetchIntervention(reponse.data.number);
			//   } else {
			//     this.$awn.alert("Errore nel salvataggio");
			//   }
		},

		resetData() {
			this.model = {
				intervention: new Intervention()
			};
		},

		paginate(array, page_size, page_number) {
			// human-readable page numbers usually start with 1, so we reduce 1 in the first argument
			return array.slice(
				(page_number - 1) * page_size,
				page_number * page_size
			);
		},
	},
};
</script>
